import { Component, Inject, OnInit, Optional } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { of, timer } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap, map } from 'rxjs/operators';
import { UserService } from '../../services/api-services/user.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { PatientDashboardService } from 'src/app/patient-dashboard/patient-dashboard.service';

@Component({
  selector: 'app-merge-account-popup',
  templateUrl: './merge-account-popup.component.html',
  styleUrls: ['./merge-account-popup.component.scss']
})
export class MergeAccountPopupComponent implements OnInit {
  searchForm: FormGroup = new FormGroup({});
  progress_spinner: boolean = false;
  dataFound: boolean = true;
  response: any[] = [];
  selectedUserId: number | null = null;
  isCheckboxChecked: boolean = false;
  mergeLoader: boolean = false;
  selectedEmail: string = '';

  constructor(
    public dialogRef: MatDialogRef<MergeAccountPopupComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public userService: UserService,
    public toast: ToastrService,
    private router: Router,
    public patientService: PatientDashboardService
  ) { }

  ngOnInit(): void {
    this.searchFormInitialize();
    this.searchFormEvent();
  }

  searchFormInitialize() {
    this.searchForm = new FormGroup({
      search: new FormControl(''),
    });
  }

  searchFormEvent() {
    this.searchForm.get('search')?.valueChanges.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      map((value: any) => {
        if (typeof value == 'object' && value !== null) {
          return Object.values(value).join('');
        }
        return value;
      }),
      switchMap((search: string) => {
        this.progress_spinner = true;
        this.dataFound = true;

        const trimmed = search?.trim();

        if (trimmed && trimmed.length >= 3) {
          const payload = { email: trimmed };
          return this.userService.mergeSearch(payload);
        } else {
          this.progress_spinner = false;
          return of({ body: { data: [], success: false } });
        }
      })
    ).subscribe(
      (res) => {
        if (res?.body?.success && res.body.data?.length > 0) {
          this.response = res.body.data;
          this.dataFound = true;
        } else {
          this.response = [];
          this.dataFound = false;
        }
        this.progress_spinner = false;
      },
      (error) => {
        console.error('error::', error);
        this.toast.error(error?.message || 'An error occurred while searching for users.');
        this.response = [];
        this.dataFound = false;
        this.progress_spinner = false;
        this.dialogRef.close();
      }
    );
  }

  onUserSelect(user: any): void {
    this.selectedEmail = user.email;
  }

  merge_process(selectedUserId: any) {
    const payload = {
      "source_id": this.data?.item?.source_id.toString(),
      "target_id": selectedUserId.toString(),
      "deleted_reason_id": this.data?.item?.from == "user-list" || "deletion-request" ? this.data?.item?.deleted_reason_id : 0
    }
    this.mergeLoader = true;
    this.userService.mergeProcess(payload).subscribe({
      next: (res => {
        if (res?.body?.success) {
          this.toast.success(res?.body?.message);
          this.mergeLoader = false;
          if (this.data?.item?.from == 'user-update') {
            this.dialogRef.close(false);
            this.navigateToUserProfile();
          } else {
            this.dialogRef.close(true);
          }
        } else {
          this.toast.error(res?.body?.message);
          this.mergeLoader = false;
        }
      }),
      error: (err => {
        console.error("err::", err);
        this.mergeLoader = false;
        this.dialogRef.close();
      })
    })
  }

  navigateToUserProfile(): void {
    this.patientService.route = '/portal/users';
    this.router.navigate(['/portal/users']);
  }

  closeModal() {
    this.dialogRef.close(false);
  }
}
